export default {"src":"/_next/static/media/img-payment-error-1.fa855630.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};